import PropTypes from 'prop-types';
import React from 'react';

const ResponseTestMessage = ({ status }) =>
  status === 'pending' ? (
    <p className="test_msg ph3 fs-12 c-black-60">
      This survey is for testing purposes only. This survey has not been
      activated. Once the survey has been set to ACTIVE, any test responses will
      be deleted and respondents will be able to complete this survey.
    </p>
  ) : null;

ResponseTestMessage.propTypes = {
  status: PropTypes.oneOf(['active', 'closed', 'pending']),
};

export default ResponseTestMessage;
